/**
 * Header Component - Displays company branding and contact info
 */

import React from 'react';
import { UIText } from './types';
import { getImageUrl } from './utils';

interface HeaderProps {
	uiText: UIText[ 'header' ];
	eventName?: string;
	printTitle?: string;
	email?: string; // Optional email from shortcode/backend to override translation
	eventDateRange?: string; // Event date range (e.g., "15.03.2026" or "15.03.2026 - 18.03.2026")
}

export const Header: React.FC< HeaderProps > = ( { uiText, eventName, printTitle, email, eventDateRange } ) => {
	// Use provided email or fall back to translation
	const displayEmail = email || uiText.email;

	return (
		<header className="sprintry-order-header">
			<div className="sprintry-order-header__branding">
				<img
					src={getImageUrl('assets/images/logo/SprintRayLogo-Original.png')}
					alt="SprintRay Logo"
					className="sprintry-order-header__logo"
				/>
				<div className="sprintry-order-header__titles">
					<h1 className="sprintry-order-header__form-title">{ printTitle || 'QUOTE REQUEST FORM' }</h1>
					{ eventName && (
						<h2 className="sprintry-order-header__event-name">
							{ eventName }
						</h2>
					) }
					{ eventDateRange && (
						<div className="sprintry-order-header__event-dates">
							{ eventDateRange }
						</div>
					) }
				</div>
				<div className="sprintry-order-header__contact">
					<span className="sprintry-order-header__contact-text">
						{ uiText.website }
					</span>
					<span className="sprintry-order-header__contact-text">
						{ displayEmail }
					</span>
				</div>
			</div>
		</header>
	);
};
